import { createReducer } from 'utils';
import config from 'config';

import {
  DATA_I18N_SET_RESOURCE,
  DATA_I18N_SET_LANGUAGE
} from '../constants';

const initialState = {
  data: [],
  language: config.defaultLang,
  languages: [
    { value: 'en', title: 'English', flag: 'gb' },
    { value: 'ru', title: 'Русский', flag: 'ru' },
    { value: 'de', title: 'Deutsch', flag: 'de' },
    { value: 'fr', title: 'Français', flag: 'fr' },
    { value: 'es', title: 'Español', flag: 'es' },
    { value: 'el', title: 'ελληνικά', flag: 'gr' },
    { value: 'it', title: 'Italiano', flag: 'it' },
    { value: 'th', title: 'ภาษาไทย', flag: 'th' }
  ]
};

export default createReducer(initialState, {
  [DATA_I18N_SET_RESOURCE]: (state, action) => {
    const { resource } = action;
    const oldData = state.data;

    const oldIndex = oldData.findIndex(r =>
      r.lang === resource.lang && r.namespace === resource.namespace);

    let newData;

    if (oldIndex === -1) {
      newData = oldData.concat(resource);
    } else {
      newData = oldData.slice();
      const newResource = Object.assign({}, newData[oldIndex], {
        resource: Object.assign({}, newData[oldIndex].resource, resource.resource)
      });

      newData.splice(oldIndex, 1, newResource);
    }

    return Object.assign({}, state, { data: newData });
  },
  [DATA_I18N_SET_LANGUAGE]: (state, action) => Object.assign({}, state, { language: action.payload.language.substr(0, 2)})
});



// WEBPACK FOOTER //
// ./src/reducers/i18n.js